// Área "investments" — preenchida na cobertura de 4 idiomas. Ver src/i18n/index.jsx.
// Fallback: idioma ausente cai para pt e, se faltar, para a própria chave.
const investments = {
  pt: {
    'investments.title': "Investimentos",
    'investments.subtitle': "Acompanhe seus aportes em CDI 100% e Bitcoin.",
    'investments.refresh': "Atualizar",
    'investments.loading': "Carregando investimentos...",
    'investments.portfolio': "Patrimônio em investimentos",
    'investments.positions_on_account': "{count} {label} na conta {account}.",
    'investments.position_singular': "posição",
    'investments.position_plural': "posições",
    'investments.total_applied': "Total aplicado",
    'investments.sum_contributions': "Soma dos aportes",
    'investments.current_balance': "Saldo atual",
    'investments.wallet_accounted': "Valor contabilizado na carteira",
    'investments.yield': "Rendimento",
    'investments.accumulated_variation': "Variação acumulada",
    'investments.available_products': "Produtos disponíveis",
    'investments.my_wallet': "Minha carteira",
    'investments.no_investments': "Nenhum investimento encontrado",
    'investments.wallet_empty_hint': "A carteira aparecerá aqui após uma aplicação.",
    'investments.current_quote': "Cotação atual",
    'investments.annual_rate': "Taxa anual",
    'investments.category': "Categoria",
    'investments.digital_asset': "Ativo digital",
    'investments.fixed_income': "Renda fixa",
    'investments.contribution_amount': "Valor do aporte",
    'investments.invest_bitcoin': "Aplicar Bitcoin",
    'investments.invest_cdi': "Aplicar 100% CDI",
    'investments.active': "Ativo",
    'investments.contract': "Contrato {n}",
    'investments.update_value': "Atualizar valor",
    'investments.applied_value': "Valor aplicado",
    'investments.accumulated_yield': "Rendimento acumulado",
    'investments.last_update': "Última atualização",
    'investments.contracted_by': "Contratado por",
    'investments.protocol': "Protocolo",
    'investments.security_confirmation': "Confirmação de segurança",
    'investments.confirm_investment': "Confirmar aplicação",
    'investments.password_prompt': "Digite a senha da conta para aplicar {amount} em {product}.",
    'investments.account_password': "Senha da conta",
    'investments.enter_password': "Digite sua senha",
    'investments.cancel': "Cancelar",
    'investments.invalid_amount': "Informe um valor de aporte válido.",
    'investments.subscription_success': "Aplicação contratada com sucesso.",
    'investments.subscription_error': "Não foi possível contratar o investimento.",
    'investments.session_error': "Não foi possível identificar a sessão da conta.",
    'investments.password_required': "Digite a senha da conta.",
    'investments.wrong_password': "Senha incorreta.",
    'investments.password_validation_error': "Não foi possível validar a senha agora.",
    'investments.value_updated': "Valor da aplicação atualizado.",
    'investments.sync_error': "Estamos atualizando essa aplicação. Tente novamente em instantes.",
    'investments.load_error': "Não foi possível carregar investimentos.",
    'investments.account_not_found': "Conta não encontrada para carregar investimentos.",
    'investments.backend_unavailable': "Backend de investimentos ainda não está disponível no ambiente selecionado.",
  },
  es: {
    'investments.title': "Inversiones",
    'investments.subtitle': "Siga sus aportes en CDI 100% y Bitcoin.",
    'investments.refresh': "Actualizar",
    'investments.loading': "Cargando inversiones...",
    'investments.portfolio': "Patrimonio en inversiones",
    'investments.positions_on_account': "{count} {label} en la cuenta {account}.",
    'investments.position_singular': "posición",
    'investments.position_plural': "posiciones",
    'investments.total_applied': "Total invertido",
    'investments.sum_contributions': "Suma de los aportes",
    'investments.current_balance': "Saldo actual",
    'investments.wallet_accounted': "Valor contabilizado en la cartera",
    'investments.yield': "Rendimiento",
    'investments.accumulated_variation': "Variación acumulada",
    'investments.available_products': "Productos disponibles",
    'investments.my_wallet': "Mi cartera",
    'investments.no_investments': "No se encontraron inversiones",
    'investments.wallet_empty_hint': "La cartera aparecerá aquí después de una inversión.",
    'investments.current_quote': "Cotización actual",
    'investments.annual_rate': "Tasa anual",
    'investments.category': "Categoría",
    'investments.digital_asset': "Activo digital",
    'investments.fixed_income': "Renta fija",
    'investments.contribution_amount': "Valor del aporte",
    'investments.invest_bitcoin': "Invertir en Bitcoin",
    'investments.invest_cdi': "Invertir 100% CDI",
    'investments.active': "Activo",
    'investments.contract': "Contrato {n}",
    'investments.update_value': "Actualizar valor",
    'investments.applied_value': "Valor invertido",
    'investments.accumulated_yield': "Rendimiento acumulado",
    'investments.last_update': "Última actualización",
    'investments.contracted_by': "Contratado por",
    'investments.protocol': "Protocolo",
    'investments.security_confirmation': "Confirmación de seguridad",
    'investments.confirm_investment': "Confirmar inversión",
    'investments.password_prompt': "Ingrese la contraseña de la cuenta para invertir {amount} en {product}.",
    'investments.account_password': "Contraseña de la cuenta",
    'investments.enter_password': "Ingrese su contraseña",
    'investments.cancel': "Cancelar",
    'investments.invalid_amount': "Ingrese un valor de aporte válido.",
    'investments.subscription_success': "Inversión contratada con éxito.",
    'investments.subscription_error': "No fue posible contratar la inversión.",
    'investments.session_error': "No fue posible identificar la sesión de la cuenta.",
    'investments.password_required': "Ingrese la contraseña de la cuenta.",
    'investments.wrong_password': "Contraseña incorrecta.",
    'investments.password_validation_error': "No fue posible validar la contraseña ahora.",
    'investments.value_updated': "Valor de la inversión actualizado.",
    'investments.sync_error': "Estamos actualizando esta inversión. Inténtelo de nuevo en unos instantes.",
    'investments.load_error': "No fue posible cargar las inversiones.",
    'investments.account_not_found': "Cuenta no encontrada para cargar las inversiones.",
    'investments.backend_unavailable': "El backend de inversiones aún no está disponible en el entorno seleccionado.",
  },
  en: {
    'investments.title': "Investments",
    'investments.subtitle': "Track your contributions in 100% CDI and Bitcoin.",
    'investments.refresh': "Refresh",
    'investments.loading': "Loading investments...",
    'investments.portfolio': "Investment holdings",
    'investments.positions_on_account': "{count} {label} in account {account}.",
    'investments.position_singular': "position",
    'investments.position_plural': "positions",
    'investments.total_applied': "Total invested",
    'investments.sum_contributions': "Sum of contributions",
    'investments.current_balance': "Current balance",
    'investments.wallet_accounted': "Value booked in the portfolio",
    'investments.yield': "Yield",
    'investments.accumulated_variation': "Accumulated change",
    'investments.available_products': "Available products",
    'investments.my_wallet': "My portfolio",
    'investments.no_investments': "No investments found",
    'investments.wallet_empty_hint': "Your portfolio will appear here after an investment.",
    'investments.current_quote': "Current quote",
    'investments.annual_rate': "Annual rate",
    'investments.category': "Category",
    'investments.digital_asset': "Digital asset",
    'investments.fixed_income': "Fixed income",
    'investments.contribution_amount': "Contribution amount",
    'investments.invest_bitcoin': "Invest in Bitcoin",
    'investments.invest_cdi': "Invest 100% CDI",
    'investments.active': "Active",
    'investments.contract': "Contract {n}",
    'investments.update_value': "Update value",
    'investments.applied_value': "Invested amount",
    'investments.accumulated_yield': "Accumulated yield",
    'investments.last_update': "Last update",
    'investments.contracted_by': "Contracted by",
    'investments.protocol': "Protocol",
    'investments.security_confirmation': "Security confirmation",
    'investments.confirm_investment': "Confirm investment",
    'investments.password_prompt': "Enter your account password to invest {amount} in {product}.",
    'investments.account_password': "Account password",
    'investments.enter_password': "Enter your password",
    'investments.cancel': "Cancel",
    'investments.invalid_amount': "Enter a valid contribution amount.",
    'investments.subscription_success': "Investment successfully subscribed.",
    'investments.subscription_error': "Could not subscribe the investment.",
    'investments.session_error': "Could not identify the account session.",
    'investments.password_required': "Enter the account password.",
    'investments.wrong_password': "Incorrect password.",
    'investments.password_validation_error': "Could not validate the password right now.",
    'investments.value_updated': "Investment value updated.",
    'investments.sync_error': "We are updating this investment. Please try again in a moment.",
    'investments.load_error': "Could not load investments.",
    'investments.account_not_found': "Account not found to load investments.",
    'investments.backend_unavailable': "Investments backend is not yet available in the selected environment.",
  },
  it: {
    'investments.title': "Investimenti",
    'investments.subtitle': "Monitora i tuoi apporti in CDI 100% e Bitcoin.",
    'investments.refresh': "Aggiorna",
    'investments.loading': "Caricamento investimenti...",
    'investments.portfolio': "Patrimonio in investimenti",
    'investments.positions_on_account': "{count} {label} nel conto {account}.",
    'investments.position_singular': "posizione",
    'investments.position_plural': "posizioni",
    'investments.total_applied': "Totale investito",
    'investments.sum_contributions': "Somma degli apporti",
    'investments.current_balance': "Saldo attuale",
    'investments.wallet_accounted': "Valore contabilizzato nel portafoglio",
    'investments.yield': "Rendimento",
    'investments.accumulated_variation': "Variazione accumulata",
    'investments.available_products': "Prodotti disponibili",
    'investments.my_wallet': "Il mio portafoglio",
    'investments.no_investments': "Nessun investimento trovato",
    'investments.wallet_empty_hint': "Il portafoglio apparirà qui dopo un investimento.",
    'investments.current_quote': "Quotazione attuale",
    'investments.annual_rate': "Tasso annuo",
    'investments.category': "Categoria",
    'investments.digital_asset': "Asset digitale",
    'investments.fixed_income': "Reddito fisso",
    'investments.contribution_amount': "Importo dell'apporto",
    'investments.invest_bitcoin': "Investi in Bitcoin",
    'investments.invest_cdi': "Investi 100% CDI",
    'investments.active': "Attivo",
    'investments.contract': "Contratto {n}",
    'investments.update_value': "Aggiorna valore",
    'investments.applied_value': "Importo investito",
    'investments.accumulated_yield': "Rendimento accumulato",
    'investments.last_update': "Ultimo aggiornamento",
    'investments.contracted_by': "Sottoscritto da",
    'investments.protocol': "Protocollo",
    'investments.security_confirmation': "Conferma di sicurezza",
    'investments.confirm_investment': "Conferma investimento",
    'investments.password_prompt': "Inserisci la password del conto per investire {amount} in {product}.",
    'investments.account_password': "Password del conto",
    'investments.enter_password': "Inserisci la tua password",
    'investments.cancel': "Annulla",
    'investments.invalid_amount': "Inserisci un importo di apporto valido.",
    'investments.subscription_success': "Investimento sottoscritto con successo.",
    'investments.subscription_error': "Non è stato possibile sottoscrivere l'investimento.",
    'investments.session_error': "Non è stato possibile identificare la sessione del conto.",
    'investments.password_required': "Inserisci la password del conto.",
    'investments.wrong_password': "Password errata.",
    'investments.password_validation_error': "Non è stato possibile validare la password ora.",
    'investments.value_updated': "Valore dell'investimento aggiornato.",
    'investments.sync_error': "Stiamo aggiornando questo investimento. Riprova tra un istante.",
    'investments.load_error': "Non è stato possibile caricare gli investimenti.",
    'investments.account_not_found': "Conto non trovato per caricare gli investimenti.",
    'investments.backend_unavailable': "Il backend degli investimenti non è ancora disponibile nell'ambiente selezionato.",
  },
};

export default investments;
